import React from "react";
import { useAppSelector } from "../../store/hooks";
import { useGetQuery } from "../../store/slices/apiSlice";
import { ProgressSpinner } from "primereact/progressspinner";
import { Spinner } from "../../pages/CRUDPages/CRUDPages.styles";
import {
  Container,
  MembersList,
  Member,
  OnlineTag,
  Label,
} from "./SessionMembersList.styles";

/**
 * Сессия текущего пользователя.
 * В API v2 нет эндпоинта «мои сессии», поэтому здесь остаётся v1 /users/me/sessions.
 */
const SessionMembersList: React.FC = () => {
  const meSessionsEP = useAppSelector((state) => state.endpoints.meSessions);
  const { data, isLoading } = useGetQuery(meSessionsEP, {
    skip: !meSessionsEP,
  });

  if (isLoading)
    return (
      <Spinner>
        <ProgressSpinner />
      </Spinner>
    );

  const sessionData = data?.[0];
  if (!sessionData) return <div>Нет данных</div>;

  const activeUsers: string[] = sessionData.activeUsers ?? [];

  return (
    <Container>
      <Label>
        Максимальное количество активных пользователей:{" "}
        {sessionData.maxActiveUsers}
      </Label>
      <Label>Активных пользователей сейчас: {activeUsers.length}</Label>

      {activeUsers.length ? (
        <MembersList>
          {activeUsers.map((user: string) => (
            <Member key={user}>
              <OnlineTag />
              <p>{user}</p>
            </Member>
          ))}
        </MembersList>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default SessionMembersList;
